import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const _8mpIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"8mp"} ref={ref}/>
});

_8mpIcon.displayName = "_8mpIcon";
